import { createContext, useContext, type ReactNode } from "react";

type ChatActions = {
  /** Send a follow-up prompt in the current chat thread (keeps everything inline). */
  ask: (prompt: string) => void;
  /**
   * Report the outcome of an inline activity (test, game, writing) back to Ada
   * as a hidden context note, so she knows the result without asking the user.
   */
  reportActivity: (note: string) => void;
};

const ChatActionContext = createContext<ChatActions>({ ask: () => {}, reportActivity: () => {} });

export function ChatActionProvider({
  ask,
  reportActivity,
  children,
}: {
  ask: (prompt: string) => void;
  reportActivity?: (note: string) => void;
  children: ReactNode;
}) {
  return (
    <ChatActionContext.Provider value={{ ask, reportActivity: reportActivity ?? (() => {}) }}>
      {children}
    </ChatActionContext.Provider>
  );
}

export function useChatActions() {
  return useContext(ChatActionContext);
}
